module.exports = __webpack_public_path__ + "static/img/superiority4.05d3dc86.png";